import { connect } from 'react-redux';
import { compose } from 'redux';

import i18n from 'services/i18n';
import MedicalInformation from 'components/DataBlock/AdaptiveDataBlock';
import { getUserFormattedDob, getUserGender } from 'store/selectors/user';
import {
  getPatientQuestionnaireResponseLoading,
  getPatientsMedicationsInfoBlock,
} from 'store/selectors/patientQuestionnaireResponse';
import withPageLoader from 'components/withPageLoader';

const mapStateToProps = state => ({
  horizontalMargin: true,
  data: [
    {
      title: 'medicalInformation.demographics',
      items: [
        { title: 'dateOfBirth', value: getUserFormattedDob(state) },
        { title: 'patient.sex', value: i18n.t(getUserGender(state)) },
      ],
    },
    { title: 'medicalInformation.medications', items: getPatientsMedicationsInfoBlock(state) },
  ],
});

export default compose(
  withPageLoader({
    loadingSelector: getPatientQuestionnaireResponseLoading,
  }),
  connect(mapStateToProps),
)(MedicalInformation);
